import './materials.css';
import Icon from '../../components/Icon';
import { useEffect, useState } from 'react';
import { useUI } from '../../UIContext';
import { get } from '../../services/api';
import { handleErr } from '../../utils/functions';

function Materials() {
    const { setMessage, setLoading } = useUI();
    const [modules, setModules] = useState([]);

    useEffect(() => {
        async function getModules() {
            setLoading(true);

            await get('/module', true, setMessage,
                (response) => {
                    setModules(response.data.filter(x => !!x.materialPath));
                },
                (err) => {
                    handleErr(setMessage, `Não foi possível carregar os materiais: ${err}`);
                },
                () => {
                    setLoading(false);
                }
            )
        }

        getModules();
    }, [setLoading, setModules, setMessage]);

    return  (
        <div className='main-container-materials'>
            <div className='glass-bg-full-page'></div>

            <h1>Materiais de Apoio</h1>
            <h3>Acesse documentos complementares para cada módulo do curso.</h3>

            {modules.map((module, index) => (
                <div
                    key={module.id}
                    className="container-white container-materials zoom-effect"
                    onClick={() => window.open(`/material/${module.id}`, '_blank', 'noopener,noreferrer')}>
                    <div className='container-material'>
                        <Icon iconClass={'icon-material'} />

                        <h2>{`Módulo ${index + 1}`}</h2>
                        
                        <div className='container-material-file container-gray'>
                            <Icon iconClass={'icon-pdf'} />

                            {module.materialFileName}
                        </div>
                    </div>


                    <Icon iconClass={'icon-right-gray-arrow'} size={16} />
                </div>
            ))}
        </div>
    );
}

export default Materials;